import * as DisplayTypes from 'customer-data-filters-ui/filterQueryFormat/DisplayTypes';
import * as DSAssetFamilies from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { ENUMERATION } from 'customer-data-objects/property/PropertyTypes';
// @ts-expect-error FIXME: Could not find a declaration file for module... Remove this comment to see the full error message
import * as ReferenceObjectTypes from 'reference-resolvers/constants/ReferenceObjectTypes';
const fieldDefinitionsByFilterFamily = {
  [DSAssetFamilies.CONTACT_PROPERTY]: {
    associatedcompanyid: {
      type: ENUMERATION,
      displayType: DisplayTypes.EnumerationDisplayType,
      fieldType: DisplayTypes.EnumerationDisplayType,
      referencedObjectType: ReferenceObjectTypes.COMPANY
    }
  },
  [DSAssetFamilies.COMPANY_PROPERTY]: {
    hs_parent_company_id: {
      type: ENUMERATION,
      displayType: DisplayTypes.EnumerationDisplayType,
      fieldType: DisplayTypes.EnumerationDisplayType,
      referencedObjectType: ReferenceObjectTypes.COMPANY
    }
  },
  [DSAssetFamilies.DEAL_PROPERTY]: {
    deal_currency_code: {
      displayType: DisplayTypes.MultiCurrencyCurrencyCode,
      fieldType: DisplayTypes.MultiCurrencyCurrencyCode,
      referencedObjectType: ReferenceObjectTypes.MULTI_CURRENCY_CURRENCY_CODE
    }
  },
  [DSAssetFamilies.LINE_ITEM_PROPERTY]: {
    hs_line_item_currency_code: {
      displayType: DisplayTypes.MultiCurrencyCurrencyCode,
      fieldType: DisplayTypes.MultiCurrencyCurrencyCode,
      referencedObjectType: ReferenceObjectTypes.MULTI_CURRENCY_CURRENCY_CODE
    }
  },
  [DSAssetFamilies.ENGAGEMENT_PROPERTY]: {
    hs_attachment_ids: {
      displayType: DisplayTypes.StringDisplayType,
      fieldType: DisplayTypes.StringDisplayType
    }
  },
  [DSAssetFamilies.LEAD_PROPERTY]: {
    hubspot_owner_id: {
      type: ENUMERATION,
      referencedObjectType: ReferenceObjectTypes.OWNER,
      displayType: DisplayTypes.EnumerationDisplayType,
      fieldType: DisplayTypes.EnumerationDisplayType
    }
  }
};
const fieldDefinitionsForAllObjects = {
  hs_merged_object_ids: {
    displayType: DisplayTypes.StringDisplayType,
    fieldType: DisplayTypes.StringDisplayType
  }
};
export const getObjectSegFieldDefinitionsForFilterFamily_v2 = filterFamily => {
  if (!filterFamily) {
    return {};
  }
  const fieldDefinitionsForFilterFamily = fieldDefinitionsByFilterFamily[filterFamily] || {};
  return Object.assign({}, fieldDefinitionsForAllObjects, fieldDefinitionsForFilterFamily);
};